// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"List_placeholder__1bN_u","placeholder-item":"List_placeholder-item__2Z32q","wrapper":"List_wrapper__3xLpT"};